import type { ScreenCredentials } from "../models/contracts";
const KEY = "mojvibe.live-stage.session.v1";
export const session = {
  load(): ScreenCredentials | null { try { const value = JSON.parse(localStorage.getItem(KEY) ?? "null") as ScreenCredentials | null; return value?.refreshToken && Date.parse(value.refreshTokenExpiresAt) > Date.now() ? value : null; } catch { return null; } },
  save(value: ScreenCredentials): void { localStorage.setItem(KEY, JSON.stringify(value)); },
  clear(): void { localStorage.removeItem(KEY); },
};
